<template>
	<div class="main-content-padding" style="height: 100%">
		<div v-if="comTabList.length" style="min-height: 100%; border-top-left-radius: 24px; border-top-right-radius: 24px" class="yx-background-white">
			<div class="yx-tab pos-rela">
				<el-tabs v-model="activeName" @tab-click="tabHandleClick">
					<el-tab-pane :label="item.name" :name="item.value" v-for="item in comTabList" :key="item.value"></el-tab-pane>
				</el-tabs>
				<el-popover @show="handleQrShow" placement="bottom" max-width="500" trigger="hover">
					<div class="qr-content flex-column flex-center">
						<img :src="wxUrl" alt="" />
						<div class="qr-title">扫码关注公众号</div>
						<div class="qr-tip">即可接收达人爆单 申样等消息通知</div>
					</div>
					<div slot="reference" class="teamAchievements_rule fz-12 flex-row-align-center flex-just-center">
						<i class="i-light-bulb"></i>
						<span class="ml-8 yx-color-text-primary">纵览业务动态，绑定公众号</span>
					</div>
				</el-popover>
			</div>
			<div class="pl-24 pr-24 pt-20">
				<multi-table
					v-loading="loading"
					ref="multiTable"
					:showPagination="false"
					:columns="columns"
					:list="tableData"
					:distanceTop="10"
				></multi-table>
			</div>
		</div>
		<empty v-else>
			<p slot="desc" class="yx-color-text-primary font-h3-regular">暂无权限</p>
		</empty>

		<el-drawer
			:wrapperClosable="false"
			class="configureMessage"
			destroy-on-close
			size="600px"
			title="消息设置"
			:visible.sync="visibleDrawer"
			direction="rtl"
		>
			<div class="pt-16 pl-16 pr-16">
				<div class="yx-background-white pl-16 pr-16 pt-20 radius-8">
					<div v-for="(item, index) in drawerForm" :key="index">
						<TextCom class="pb-28" :info="item" v-if="item.type == 'text'" />
						<ComposeCom class="pb-16" :ref="'condition' + item.condition_key" :info="item" v-if="item.type == 'condition'" />
						<CheckboxCom :ref="item.content.send_key" :info="item" v-if="item.type == 'checkbox'" />
						<CheckboxCom
							:ref="item.content.send_key"
							:info="item"
							v-if="item.type == 'receiver' && item.content.receiver_type != 'receiver_type_partner_anchor'"
						/>
						<Add-staff
							class="pb-28"
							:ref="item.content.send_key"
							:info="item"
							v-if="item.type == 'receiver' && item.content.receiver_type == 'receiver_type_partner_anchor'"
						/>
					</div>
				</div>
			</div>

			<div style="height: 80px"></div>
			<div class="configure_message_drawer_footer mt-20 yx-border-top">
				<el-button style="width: 88px" @click="visibleDrawer = false">取消</el-button>
				<el-button :loading="submitLoading" type="primary" style="width: 88px" @click="handleSubmit">保存</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import TextCom from './components/index/textCom.vue';
import ComposeCom from './components/index/compose';
import CheckboxCom from './components/index/checkboxCom';
import AddStaff from './components/index/addStaff';
import { getMessageConfList, messageSave } from '@/api/settings';
import { checkFollow } from '@/api/common';
import { columns } from './columns';
export default {
	data() {
		return {
			columns,
			tabList: Object.freeze([
				{
					name: '达人提醒',
					value: 'anchor',
					auth: 'notification:type_daren_notice',
				},
				{
					name: '样品提醒',
					value: 'sample_order',
					auth: 'notification:type_sample_notice',
				},
				{
					name: '合作提醒',
					value: 'type_cooperate_notice',
					auth: 'notification:type_cooperate_notice',
				},
				{
					name: '内容提醒',
					value: 'content',
					auth: 'notification:type_content_notice',
				},
				{
					name: '商团协作',
					value: 'business',
					auth: 'notification:type_applyCooperation_notice',
				},
				{
					name: '其他提醒',
					value: 'other',
					auth: 'notification:type_other_notice',
				},
			]),
			activeName: 'anchor',
			activeDrawer: {},

			tableData: [],
			visiblePopover: false,
			visiblePopoverType: '',
			visibleDrawer: false,

			drawerForm: [],
			loading: false,
			submitLoading: false,
			wxUrl: '',
		};
	},
	provide() {
		return {
			injectGetList: this.getConfList,
			injectActiveName: () => this.activeName,
		};
	},
	components: {
		TextCom,
		ComposeCom,
		CheckboxCom,
		AddStaff,
		
	},
	methods: {
		async handleQrShow() {
			console.log('handleQrShow');
			const { code, data } = await checkFollow({});
			if (code !== 0) return;
			this.wxUrl = data.wx_url;
		},
		tabHandleClick() {
			this.getConfList();
		},
		handleStatusChange(row) {
			this.visiblePopoverType = row.sub_type;
			this.visiblePopover = true;
		},
		handleDrawer(item) {
			this.activeDrawer = item;
			this.drawerForm = item.drawer_form ? JSON.parse(item.drawer_form) : [];
			this.visibleDrawer = true;
		},

		async handleSubmit() {
			const params = {
				type: this.activeName,
				sub_type: this.activeDrawer.sub_type,
				id: this.activeDrawer.id,
			};
			for (let i = 0; i < this.drawerForm.length; i++) {
				const item = this.drawerForm[i];
				if (item.type == 'condition') {
					!params.send_condition && (params.send_condition = []);
					const val = await this.$refs['condition' + item.condition_key][0].getValue();
					params.send_condition.push({
						condition_key: item.condition_key,
						list: val,
					});
				}
				if (item.type == 'receiver') {
					params[item.content.send_key] = await this.$refs[item.content.send_key][0].getValue();
				}
				if (item.type == 'checkbox') {
					params[item.content.send_key] = await this.$refs[item.content.send_key][0].getValue();
				}
			}
			this.submitLoading = true;
			try {
				await messageSave(params);
				this.visibleDrawer = false;
				this.$message.success('保存成功');
				this.getConfList();
			} catch (error) {}
			this.submitLoading = false;
		},
		async getConfList() {
			this.loading = true;
			const res = await getMessageConfList({ type: this.activeName });
			// const res = mock_msgList
			this.tableData = res.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			const cooperateAuth = {
				//交付提醒 和 爆单提醒额外有权限控制
				cooperate_timeout_not_delivered: 'notification:st_cooperate_notice_deliver',
				receive_timeout_not_delivered: 'notification:st_cooperate_notice_deliver',
				st_cooperate_notice_explosion: 'notification:st_cooperate_notice_explosion',
			};
			this.tableData = this.tableData.filter(item => {
				if (item.sub_type in cooperateAuth) {
					return this.$auth.hasPermi(cooperateAuth[item.sub_type]);
				}
				return true;
			});
			this.loading = false;
		},
		getButtons(item) {
			const arr = [];
			arr.push({
				label: '设置',
				type: 'text',
				classtype: 2,
				isShow: true,
				disabled: item.set_status != 1,
				click: item => this.handleDrawer(item),
			});
			return arr.filter(item => item.isShow);
		},
	},
	computed: {
		comTabList() {
			return this.tabList.filter(item => this.$auth.hasPermi(item.auth));
		},
	},
	created() {
		if (this.comTabList.length != 0) {
			this.activeName = this.comTabList[0].value;
			this.getConfList();
		}
	},
};
</script>

<style lang="less" scoped>
.yx-tab /deep/ .el-tabs__nav-wrap {
	padding: 0 0 0 24px;
}
.el-table thead {
	font-size: 12px;
}
.configure_message_drawer_footer {
	position: absolute;
	bottom: 0;
	left: 0;
	padding: 16px;
	width: 100%;
	text-align: right;
	background: #fff;
}
::v-deep .el-table .cell {
	font-size: 12px;
}
.listTable {
	::v-deep tbody {
		color: @color-text-primary;
	}
}
</style>

<style lang="less">
.configureMessage {
	.el-drawer__body {
		background: @color-gy2;
	}
}
.yx-tab {
	position: relative;
}
.teamAchievements_rule {
	position: absolute;
	background: #fff6f2;
	right: 24px;
	top: 10px;
	padding: 0 12px;
	border-radius: 30px;
	height: 30px;
	line-height: 30px;
	cursor: pointer;
	// position: absolute;
	// right: 0px;
	// top: 0px;
	.teamAchievements_rule_icon {
		width: 16px;
		height: 16px;
	}
}
.qr-content {
	img {
		width: 160px;
		height: 160px;
	}
	.qr-title {
		width: 98px;
		margin-top: 6px;
		font-family: Source Han Sans;
		font-size: 14px;
		font-weight: bold;
		line-height: normal;
		letter-spacing: 0em;

		font-variation-settings: 'opsz' auto;
		font-feature-settings: 'kern' on;
		color: #3d3d3d;
	}
	.qr-tip {
		width: 98px;
		font-family: Source Han Sans;
		font-size: 12px;
		font-weight: normal;
		line-height: normal;
		text-align: center;
		letter-spacing: 0em;

		font-variation-settings: 'opsz' auto;
		font-feature-settings: 'kern' on;
		/* 超/灰/G7 */
		color: #86909d;
	}
}
</style>
